import { render, staticRenderFns } from "./textContent.vue?vue&type=template&id=c676145a&scoped=true&"
import script from "./textContent.vue?vue&type=script&lang=js&"
export * from "./textContent.vue?vue&type=script&lang=js&"
import style0 from "./textContent.vue?vue&type=style&index=0&id=c676145a&prod&lang=scss&"
import style1 from "./textContent.vue?vue&type=style&index=1&id=c676145a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c676145a",
  null
  
)

export default component.exports